import React, { useContext, useEffect, useRef, useState } from "react";
import { IconButton, Stack, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/HighlightOff";
import HideIcon from "@mui/icons-material/VisibilityOff";
import ShowIcon from "@mui/icons-material/Visibility";
import { useDispatch, useSelector } from "react-redux";
import { hideChat } from "../../../action/chat";
import {
  getAudienceId,
  getUserId,
  isMobile,
  putStreamRecord,
  formatJsonToSingleLine,
  truncate
} from "../../../constants/function";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import MusicNoteAnimation from "../MusicNoteAnimation";
import { SocketContext } from "../../../context/socket";
import emitter from '../../../EventEmitter';
import CloseFullScreenIcon from '@mui/icons-material/FullscreenExit';
import OpenFullScreenIcon from '@mui/icons-material/Fullscreen';
import Circle from '@mui/icons-material/Circle';
import MusicNote from '@mui/icons-material/MusicNote';
import { updateStreamCount } from "../../../action/streamCount";
import cookieStorage from "../../../services/cookie-storage";

export default function StreamHeader({
  title,
  isOwner,
  isJoined,
  playlistId,
  streamSong,
  obs,
  isFullScreen
}) {
  const token = cookieStorage.getCookie("Authorization");
  const { songs, index, track, pos } = useSelector((state) => state.streamSong);
  const liveUsers = useRef([]);
  const socket = useContext(SocketContext).Socket;
  const { t } = useTranslation("common");
  const history = useHistory();
  const [isHidden, setIsHidden] = React.useState(false);
  const dispatch = useDispatch();
  const [songData, setSongData] = React.useState({});
  const [channelListenIncrement, setChannelListenIncrement] = React.useState(0);
  const { streamCount } = useSelector((state) => state.streamCount);
  const seek = useSelector((state) => state.seek);
  const [callCount, setCallCount] = useState(0);

  const toggleFullScreen = () => {
    if (isFullScreen) emitter.emit("closeFullScreen");
    else emitter.emit("openFullScreen");
  }

  useEffect(() => {
    if (!seek?.started && track?.currentState === 'playing' && index >= 0 && pos > 0) {
      calculateStreamCount();
      setCallCount(prevCount => prevCount + 1);
    } else if (!seek?.started && track?.currentState === "stopped" && callCount < Math.floor(track?.duration)) {
      calculateStreamCount();
      setCallCount(0);
    } else if (!seek?.started && track?.currentState === "stopped" && callCount >= Math.floor(track?.duration)) {
      dispatch(updateStreamCount(Math.round(streamCount)));
      setCallCount(0);
    }
  }, [pos]);

  const calculateStreamCount = () => {
    const timeElapsed = 1;
    const flooredDuration = Math.floor(track?.duration);
    const percentListened = timeElapsed / flooredDuration;
    const audienceCount = liveUsers?.current.length || 1;
    const streamIncrement = percentListened * audienceCount;
    const incrCount = streamCount + streamIncrement;

    // console.log(JSON.stringify({
    //   function: 'calculateStreamCount',
    //   flooredDuration,
    //   percentListened,
    //   audienceCount,
    //   streamIncrement,
    //   incrCount,
    //   streamCount,
    //   callCount
    // }));

    dispatch(updateStreamCount(incrCount));
  };

  useEffect(() => {
    if (socket && isJoined && isOwner) {
      socket.emit("livestream-streamcount", { JWT: token, streamCount, channelName: playlistId });
    }
  }, [streamCount]);

  useEffect(() => {
    emitter.on('hideStream', hideStream);
    emitter.on('showStream', showStream);

    return () => {
      if (emitter) {
        // emitter.off('hideStream', hideStream);
        // emitter.off('showStream', showStream);
      }
    }
  }, []);

  const hideStream = async () => {
    try {
      emitter.emit('closeNft');
      const doc = document.getElementById("__streaming_container");
      const streamTippers = document.getElementById("_streamTippers");
      const streaming_control = document.getElementById("_streaming_control");
      const streaming_canvas = document.getElementById("_streaming_canvas");
      doc.style.display = "none";
      if (streamTippers) streamTippers.style.display = "none";
      if (streaming_control) streaming_control.style.display = "none";
      if (streaming_canvas) streaming_canvas.style.display = "none";
      setIsHidden(true);
    } catch (error) { }
  };

  const showStream = async () => {
    try {
      const doc = document.getElementById("__streaming_container");
      const streamTippers = document.getElementById("_streamTippers");
      const streaming_control = document.getElementById("_streaming_control");
      const streaming_canvas = document.getElementById("_streaming_canvas");
      doc.style.display = "block";
      if (streamTippers) streamTippers.style.display = "block";
      if (streaming_control) streaming_control.style.display = "flex";
      if (streaming_canvas) streaming_canvas.style.display = "flex";
      setIsHidden(false);
    } catch (error) { }
  };

  useEffect(() => {
    if (
      isJoined &&
      isOwner &&
      history.location.pathname.includes("/LiveVideoStreaming")
    ) {
      const shareScreenBtn = document.getElementById("_share_screen_btn");
      if (shareScreenBtn) shareScreenBtn.style.display = "none";
    }
  }, [isJoined]);

  useEffect(() => {
    if (socket) {
      socket.on("livestream-streams", (data) => {
        console.log("** socket livestream-streams: " + formatJsonToSingleLine(data))
        if (data.channelName === playlistId) {
          setChannelListenIncrement(data.increment);
        }
      });

      socket.on("livestream-streamcount", (data) => {
        if (data.channelName === playlistId && !isOwner) {
          dispatch(updateStreamCount(data.streamCount));
        }
      });
    }
  }, [socket]);

  useEffect(() => {
    if (socket) {
      socket.on("song-started", (data) => {
        console.log("** socket song-started: " + formatJsonToSingleLine(data))
        if (data.roomId === playlistId) setSongData({ ...data });
      });
      socket.on("audience-in-stream", handleAudience);
    }
    if (streamSong) {
      setSongData({ ...streamSong });
    }
  }, [socket, streamSong]);

  const handleAudience = (data) => {
    console.log("** socket audience-in-stream: " + formatJsonToSingleLine(data))
    if (
      data.channelName &&
      data.channelName === playlistId &&
      data.liveUsers.length !== liveUsers.current.length
    ) {
      console.log(track);
      const playingIndex = localStorage.getItem("streamIndex");
      if (songs.length > 0 && playingIndex && playingIndex >= 0) {
        const curretTimeInSong = parseFloat(
          localStorage.getItem("curretTimeInSong")
        );
        putRecord(
          "stop",
          songs[playingIndex]._id,
          playlistId,
          playingIndex,
          curretTimeInSong ? curretTimeInSong : 0,
          new Date().getTime(),
          songs,
          liveUsers.current
        );
        putRecord(
          "start",
          songs[playingIndex]._id,
          playlistId,
          playingIndex,
          curretTimeInSong ? curretTimeInSong : 0,
          new Date().getTime(),
          songs,
          data.liveUsers
        );
      }
      liveUsers.current = data.liveUsers;
    }
  };

  const putRecord = async (
    event,
    musicId,
    playlistId,
    index,
    timeInSong,
    associationId,
    playlistSongs,
    liveUserData
  ) => {
    const userId = getUserId();
    const audienceArray = await getAudienceId(liveUserData);
    const payload = {
      eventType: event,
      timestamp: new Date().getTime(),
      userId: userId,
      musicId: musicId,
      playlistId: playlistId,
      livestreamId: playlistId,
      songDetails: playlistSongs[index],
      timeInSong: timeInSong,
      associationId: associationId,
      audienceArray: audienceArray,
    };
    putStreamRecord(payload);
  };

  return (
    <Stack
      className="_streaming_header"
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      sx={{
        borderBottom: "1px solid #FFFFFF19",
      }}
    >
      <Stack direction="row" alignItems="center">
        <IconButton id="closeIcon"
          title={t("stream.tooltip3")}
          onClick={() => emitter.emit("endStream")}
        >
          <CloseIcon className="_cp" color="default" />
        </IconButton>

        <IconButton className="btn" onClick={toggleFullScreen}>
          {isFullScreen ? (
            <CloseFullScreenIcon className="icon" />
          ) : (
            <OpenFullScreenIcon className="icon" />
          )}
        </IconButton>

        <IconButton id="hideShowIcon"
          title={isHidden ? t("stream.tooltip1") : t("stream.tooltip2")}
          onClick={() => (isHidden ? showStream() : hideStream())}
        >
          {isHidden ? (
            <ShowIcon className="_cp" color="default" />
          ) : (
            <HideIcon className="_cp" color="default" />
          )}
        </IconButton>
      </Stack>

      <Stack
        className="_streaming_header_container"
        alignItems="center"
        spacing={1}
        direction="row"
      >

        <div style={{
          paddingLeft: '20px',
          borderLeft: '2px solid #ccc'
        }} />

        <Circle style={{
          color: 'green',
          width: 15,
          height: 15,
        }} className="_cp" color="default" />

        <Typography className="fs-17">
          {title}
        </Typography>

        <MusicNote sx={{ color: 'yellow' }} className="_cp" color="default" />
        <span className="color-green-500">{Math.floor(streamCount)}</span>

      </Stack>

      {/*{!isOwner && songData?.song ? (*/}
      {/*  <MusicNoteAnimation song={songData} />*/}
      {/*) : null}*/}
    </Stack>
  );
}
